import React from "react";
import { FormattedMessage } from "react-intl";
import {
  ObjectStatusCssClasses,
  ObjectActiveTitles
} from "../../ObjectsUIHelpers";

export const IsActiveColumnFormatter = (cellContent, row) => {
  const isActive = row.isActive !== undefined ? row.isActive : cellContent;
  const statusIndex = +!isActive; // 1 for active (enabled), 0 for inactive (disabled)
  
  return (
    <span
      className={`label label-lg label-light-${ObjectStatusCssClasses[statusIndex]} label-inline`}
    >
      <FormattedMessage id={ObjectActiveTitles[statusIndex]} />
    </span>
  );
};
